var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-snackbar',{attrs:{"timeout":4000,"bottom":""},model:{value:(_vm.statesMessage),callback:function ($$v) {_vm.statesMessage=$$v},expression:"statesMessage"}},[_vm._v(_vm._s(_vm.stateText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }